import(/* webpackMode: "eager" */ "/opt/buildhome/repo/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/opt/buildhome/repo/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/opt/buildhome/repo/components/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LangProvider"] */ "/opt/buildhome/repo/components/LangProvider.tsx");
